/**
 * Recomendaciones de producto («Completa tu rutina», «También te puede gustar»).
 * Se cargan cuando la sección se acerca a la pantalla.
 */
import { parseHTML } from '@theme/global';

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    if (!('IntersectionObserver' in window)) {
      this.load();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.load();
      },
      { rootMargin: '0px 0px 600px 0px' }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load() {
    this.dataset.loaded = 'true';
    try {
      const response = await fetch(this.dataset.url);
      const next = parseHTML(await response.text()).querySelector('product-recommendations');
      if (!next) return;

      const limit = parseInt(this.dataset.limit, 10) || 4;
      next.querySelectorAll(`[data-product-id="${this.dataset.productId}"]`).forEach((card) => {
        card.closest('[data-grid-item]')?.remove();
      });
      [...next.querySelectorAll('[data-grid-item]')].slice(limit).forEach((item) => item.remove());

      if (!next.querySelector('[data-grid-item]')) return;
      this.innerHTML = next.innerHTML;
      this.classList.add('is-loaded');
    } catch (err) {
      // Sin recomendaciones: la sección queda vacía.
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
